<template>
  <v-container>
    <taxRollSummaryUI />
  </v-container>
</template>

<script>
import taxRollSummaryUI from '../../components/shared/taxRollSummary/taxRollSummaryList.vue';

export default {
  name: 'taxRollSummary',
  components: {
    taxRollSummaryUI,
  },
};
</script>
